import { FC, useEffect, useState } from 'react';
import { MainInfo } from 'components/BlocksContent/MainInfo';
import { MainDocument } from 'components/BlocksContent/MainDocument';
import * as slice from 'redux/mainInfo/slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { TabEmployeds } from 'components/TabEmployeds';
import { setInfoEmployeds } from 'redux/employedDetail/slice';
import { FNSStatus } from 'components/BlocksContent/FNSStatus';
import styles from './WorkerContent.module.scss';
import { ResponseEmployedType } from 'redux/Api/employedsWorkSupportApi/type';
import { Button } from 'ui/Button';
import { useDeleteEmployedMutation } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { Loader } from '@mantine/core';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { Modal } from 'components/Modal';
import { Title } from 'components/Title';

interface WorkerContentTypes {
  workerId: number | string;
  data: (ResponseEmployedType & Record<string, unknown>) | undefined;
}

export const WorkerContent: FC<WorkerContentTypes> = ({ workerId, data }) => {
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showModalErrors, setShowModalErrors] = useState(false);
  const [textErrorDelete, setTextErrorDelete] = useState<string[]>([]);
  const { infoEmployeds } = useSelector((state: RootState) => state.employedsDetailSlice);
  const dispatch = useDispatch();
  const [deleteEmployed, { isLoading }] = useDeleteEmployedMutation();
  useEffect(() => {
    if (data) {
      for (const key in data) {
        dispatch(setInfoEmployeds({ key, value: data[key] }));
      }
      dispatch(slice.setlistTabs(data?.lists?.available_tabs || []));
      dispatch(slice.setWorkerId(workerId));
    }
  }, [workerId, data]);

  const handleDeleteEmployed = async () => {
    const expectedPassword = process.env.REACT_APP_PASSWORD_UPDATE_PROFILE || '';
    const enteredPassword = window.prompt('Введите пароль для удаления профиля');

    if (enteredPassword === null) return;
    if (enteredPassword !== expectedPassword) {
      window.alert('Неверный пароль');
      return;
    }
    try {
      await deleteEmployed({ id: Number(workerId) }).unwrap();
      setTextErrorDelete([]);
      setShowDeleteSuccess(true);
    } catch (error) {
      console.error(error);
      setTextErrorDelete((error as { data?: { errors?: string[] } }).data?.errors || []);
      setShowModalErrors(true);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.back}>
        <p className={styles.back_title}>
          {infoEmployeds?.surname +
            ' ' +
            infoEmployeds?.name +
            ' ' +
            infoEmployeds?.patronymic}
        </p>
        {!infoEmployeds.is_deleted && (
          <Button
            theme='danger'
            onClick={isLoading ? undefined : handleDeleteEmployed}
            size='S'>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              Удалить профиль {isLoading && <Loader size='xs' color='#e10d0d' />}
            </div>
          </Button>
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.left}>
          <MainInfo />
          <MainDocument />
          <FNSStatus />
        </div>
        <div className={styles.right}>
          <TabEmployeds />
        </div>
      </div>
      {showDeleteSuccess && (
        <SuccessErrorInfo
          type={'success'}
          text={'Профиль удален'}
          handleClose={() => setShowDeleteSuccess(false)}
        />
      )}
      {showModalErrors && (
        <Modal setOpen={setShowModalErrors} open={showModalErrors}>
          <div className={styles.modal}>
            <div>
              <Title title='Ошибки при удалении профиля' />
            </div>
            <div className={styles.modal_text}>
              {textErrorDelete.length > 0 ? (
                textErrorDelete.map((item, index) => (
                  <p key={`${index}-${item}`} className={styles.modal_text}>
                    {index + 1}. {item}
                  </p>
                ))
              ) : (
                <p className={styles.modal_text}>Не удалось удалить профиль</p>
              )}
            </div>
            <div className={styles.modal_btnGroup}>
              <Button
                onClick={() => setShowModalErrors(false)}
                className={styles.modal_btn}
                theme='filed'>
                Закрыть
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
